/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState ,useRef , useEffect} from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import { getSessionState } from "../../hooks/useSessionState";
import Filtro from "../../shared/componentes/filtro";
import FieldMultiSelect from "../../shared/controls/fieldMultiSelect";
import { Sidebar } from "primereact/sidebar";
import FieldTextBox from "../../shared/controls/fieldTextBox";
import useApiLiquidaciones from "../../api/administracion/useApiLiquidaciones";
import LiquidacionDetalle from "./liquidacionDetalle";
import alerts from "../../shared/alerts";
import constantes from "../../catalogos/constantes";
import FieldCheckBox from "../../shared/controls/fieldCheckBox";
import useSeguridad from "../../Seguridad/useSeguridad";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import { useAuth } from "../../Seguridad/AuthProvider";
import { Dialog } from "primereact/dialog";
import FieldTextArea from "../../shared/controls/fieldTextArea";
import { Button } from "primereact/button";
const Liquidacion = ({ esquemaPago, semanaLaboral, soloLectura, consulta }) => {
  // const nombreEsquema = () => {
  //   if (esquemaPago === constantes.esquemaPago.liquidacion) return "Operativa";
  //   if (esquemaPago === constantes.esquemaPago.staff) return "Staff";
  //   if (esquemaPago === constantes.esquemaPago.oficina) return "Oficina";
  //   if (esquemaPago === constantes.esquemaPago.OutsourcingExterno)
  //     return "OutsourcingExterno";
  //   return "Otro";
  // };
    const filtroKey = 'FiltroLiquidacion';
    const esOperador = esquemaPago === constantes.esquemaPago.liquidacion;
    const [datos, setDatos] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [liquidacion, setLiquidacion] = useState({});
    const filtroRef = useRef();
    const [empresaUsuario, setEmpresaUsuario] = useState([]);
    const apiLiquidacion = useApiLiquidaciones();
    const seguridad = useSeguridad();
    const permisoEmpleadosEnBaja = seguridad.tieneAcceso(constantes.opciones.LiquidacionEmpleadosBaja);
    const { user: usuario } = useAuth(); 
    const username = usuario.username;
    const liquidacionEnProcesoRef = useRef(false);
    const puedeAprobar= seguridad.tieneAcceso(constantes.opciones.permisoAprobarCoordinador);
    const puedeLiquidarMasivo= seguridad.tieneAcceso(constantes.opciones.permisoLiquidarMasivo);
    const accion = esOperador  ? (puedeAprobar ? "Aprobar" : "Liquidar")  : "Liquidar";
    const [comentario, setComentario]= useState("");
    const [verModal, setVerModal]= useState(false);
    const [empleadoSeleccionado,  setEmpleadoSeleccionado]= useState("");
    const [liquidarSinRendimiento,setliquidarSinRendimiento]= useState(true);
    const [idEmpleado, setidEmpleado] = useState([]);
   useEffect(() => {
        const obtenerEmpresasUsuario = async () => {
            try {
                const empresas = await apiLiquidacion.obtenerEmpresaUsuario({ username });
                setEmpresaUsuario(empresas)
            
            } catch (error) {
                console.error("Error al cargar empleados activos:", error);
            }
        };
        obtenerEmpresasUsuario();
    }, [username]);
    const onGridReady = async (params) => {
        setGridApi(params.api);
    };  
    function ObtenerFiltro(filtro) {
        filtro = filtro ?? getSessionState(filtroKey);
        filtroRef.current = filtro; 
        console.log(filtro)
        return { ...filtro, esquemaPago: esquemaPago, coordinadorIds: filtro.coordinadorIds?.id, unidadNegocioId: filtro.unidadNegocioId?.id, estatusId: filtro.estatusId?.id}
    }

  async function buscar(filtro, paramsApi) {
    agGridHelper.showLoad(gridApi, paramsApi, true);
    filtro = ObtenerFiltro(filtro);
    // if (!filtro.empresa) {
    //     alerts.aviso("Debe seleccionar una empresa para buscar.");
    //     return;
    // }
    let datos = await apiLiquidacion.filtrar(filtro);
    setDatos(datos);
    console.log(datos)
    agGridHelper.hideLoad(gridApi, paramsApi, false);
  }

  const verMovimiento = async (empleadoId) => {
    let filtro = ObtenerFiltro();
    await apiLiquidacion.obtener(empleadoId, filtro).then((liquidacionA) => {
      setSidebarVisible(true);
      setLiquidacion(liquidacionA);
    });
  };

  function exportar() {
    let filtro = ObtenerFiltro();
    apiLiquidacion.excel(filtro);
  }

  async function onSave() {
    setSidebarVisible(false);
    await buscar();
  }

  async function liquidarAdministrativos(api) {
    if (liquidacionEnProcesoRef.current) {
      alerts.aviso("La liquidación ya está en proceso. Por favor, espere.");
      return;
    }

    const rows = api.getSelectedRows();
    if (!rows.length) {
      alerts.aviso("Debe seleccionar mínimo un empleado");
      return;
    }

    if (!(await alerts.preguntarSiNo("¿Está seguro de generar la liquidación?")))
      return;

    liquidacionEnProcesoRef.current = true;

    try {
      const ids = rows.map((e) => e.empleado.id);

      const res = await apiLiquidacion.liquidacionAdministrativa({ ids, esquemaPago });

      const errores = res?.errores ?? [];
      if (errores.length > 0) {
        const detalle = errores
          .slice(0, 10)
          .map((x) => (typeof x === "string" ? x : x?.mensaje || x?.message || JSON.stringify(x)))
          .join("\n");

        alerts.aviso(
          `Liquidación terminada con errores.\nProcesados: ${res?.procesados ?? 0}\nErrores: ${errores.length}\n\n${detalle}`
        );
      } else {
        alerts.aviso(`Liquidación terminada. Procesados: ${res?.procesados ?? ids.length}`);
      }

      await onSave();
    } catch (e) {
      console.error("Error al generar la liquidación:", e);

      const data = e?.response?.data;
      const mensaje =
        data?.message ||
        data?.Mensaje ||
        (typeof data === "string" ? data : null) ||
        e?.message ||
        "Error al generar la liquidación.";

      alerts.aviso(mensaje);
    } finally {
      liquidacionEnProcesoRef.current = false;
    }
  }

  async function liquidarOperadores(api) {
        if (liquidacionEnProcesoRef.current) {
      alerts.aviso("La liquidación ya está en proceso. Por favor, espere.");
      return;
    }

    const rows = api.getSelectedRows();
    if (!rows.length) {
      alerts.aviso("Debe seleccionar mínimo un empleado");
      return;
    }

    if (!(await alerts.preguntarSiNo("¿Está seguro de generar la liquidación?")))
      return;

    liquidacionEnProcesoRef.current = true;

    try {
      const ids = rows.map((e) => e.empleado.id);

      const res = await apiLiquidacion.liquidarOperadoresMasivo({ ids, esquemaPago });

      const errores = res?.errores ?? [];
      if (errores.length > 0) {
        const detalle = errores
          .slice(0, 10)
          .map((x) => (typeof x === "string" ? x : x?.mensaje || x?.message || JSON.stringify(x)))
          .join("\n");

        alerts.aviso(
          `Liquidación terminada con errores.\nProcesados: ${res?.procesados ?? 0}\nErrores: ${errores.length}\n\n${detalle}`
        );
      } else {
        alerts.aviso(`Liquidación terminada. Procesados: ${res?.procesados ?? ids.length}`);
      }

      await onSave();
    } catch (e) {
      console.error("Error al generar la liquidación:", e);

      const data = e?.response?.data;
      const mensaje =
        data?.message ||
        data?.Mensaje ||
        (typeof data === "string" ? data : null) ||
        e?.message ||
        "Error al generar la liquidación.";

      alerts.aviso(mensaje);
    } finally {
      liquidacionEnProcesoRef.current = false;
    }
  }
  const guardar = async () => {      
      const ids = idEmpleado;
      await apiLiquidacion.aprobarPorCoordinador({ ids, esquemaPago, liquidarSinRendimiento, comentario});
      setComentario("")
      setliquidarSinRendimiento(false)
      setVerModal(false);
  }
  const renderFooterModal = () => (
      <div className="p-1">
          <Button label="Cancelar" onClick={() => verModal(false)}  className="p-button-outlined" />
          <Button label="Guardar" onClick={guardar}  autoFocus />
      </div>
  );
async function aprobarOperadores(api) {
  if (liquidacionEnProcesoRef.current) {
    alerts.aviso("La aprobación ya está en proceso. Por favor, espere.");
    return;
  }

  const rows = api.getSelectedRows();
    if (!rows.length) {
      alerts.aviso("Debe seleccionar mínimo un empleado");
      return;
    }

    if (!(await alerts.preguntarSiNo("¿Está seguro de generar la aprobación?")))
      return;

    liquidacionEnProcesoRef.current = true;

    try {
      const ids = rows.map((e) => e.empleado.id);

      const res = await apiLiquidacion.aprobarPorCoordinador({ ids, esquemaPago });
      console.log(res)
      const errores = res?.errores ?? [];
      if (errores.length > 0) {
        const detalle = errores
          .slice(0, 10)
          .map((x) =>
            typeof x === "string"
              ? x
              : x?.mensaje || x?.message || JSON.stringify(x)
          )
          .join("\n");

        alerts.aviso(
          `Aprobación terminada con errores.\nProcesados: ${res?.procesados ?? 0}\nErrores: ${errores.length}\n\n${detalle}`
        );
         if (detalle.includes("Su último rendimiento")) {
          setVerModal(true);        
          setEmpleadoSeleccionado(res.nombresEmpleados);
          setidEmpleado(res.empleadoId);
        }
        return;
        
      } else {
        alerts.aviso(
          `Aprobación terminada. Procesados: ${res?.procesados ?? ids.length}`
        );
      }

      await onSave();
    } catch (e) {
      console.error("Error al generar la aprobación:", e);

      const data = e?.response?.data;
      const mensaje =
        data?.message ||
        data?.Mensaje ||
        (typeof data === "string" ? data : null) ||
        e?.message ||
        "Error al generar la aprobación.";

      alerts.aviso(mensaje);
    } finally {
      liquidacionEnProcesoRef.current = false;
    }
  }
  const ButtonsHeader = ({ api }) => {
    return (
      <div className="ag-grid header-icons">
        
        <>
          {!esOperador && !soloLectura && (
            <ButtonIcon
              title="Liquidar"
              onClick={() => liquidarAdministrativos(api)}
              iconName="BiListCheck"
            />
          )}
        </>
         <>
          {(esOperador && puedeLiquidarMasivo&& !soloLectura )&& (
            <ButtonIcon
              title="Liquidar Operadores"
              onClick={() => liquidarOperadores(api)}
              iconName="BiListCheck"
            />
          )}
           {(esOperador && puedeAprobar && !soloLectura) && (
            <ButtonIcon
              title="Aprobar Operadores"
              onClick={() => aprobarOperadores(api)}
              iconName="BiCheckDouble"
              size={16}
            />
          )}
        </>
        <ButtonIcon
          title="Descargar"
          onClick={exportar}
          iconName="BiDownload"
        />
      </div>
    );
  };

  const RowButtons = ({ data }) => (
    <div className="ag-grid row-icons">
      <button
        className="btn btn-link btn-sm"
        title={"Editar"}
        onClick={() => verMovimiento(data.empleado.id)}
      >
        Ver
      </button>
    </div>
  );

  return (
    <>
      <Filtro
        filtroKey={filtroKey}
        handleSubmit={buscar}
        filtrarAlInicio={false}
      >
        <Filtros
          esOperador={esOperador}
          esquemaPago={esquemaPago}
          semanaLaboral={semanaLaboral}
          consulta={consulta}
          permisoEmpleadosEnBaja={permisoEmpleadosEnBaja}
          empresaUsuario={empresaUsuario}
        />
      </Filtro>

      <Sidebar
        visible={sidebarVisible}
        position="right"
        dismissable={false}
        className="p-sidebar-xl"
        onHide={() => setSidebarVisible(false)}
      >
        <LiquidacionDetalle
          liquidacionActual={liquidacion}
          esOperador={esOperador}
          onClose={() => setSidebarVisible(false)}
          soloLectura={soloLectura}
          esquemaPago={esquemaPago}
        />
      </Sidebar>

      <div className="ag-theme-balham grid-principal">
        <AgGridReact
          enableSorting={true}
          enableFilter={true}
          pagination={true}
          frameworkComponents={{
            buttonsHeader: ButtonsHeader,
            rowButtons: RowButtons,
            imageFormatter: agGridHelper.ImageFormatter,
            dateFormatter: agGridHelper.DateTimeFormatter,
          }}
          onGridReady={onGridReady}
          rowData={datos}
          overlayLoadingTemplate={agGridHelper.loadingOverlay}
          defaultColDef={agGridHelper.defaultColumns}
          rowHeight={35}
          rowSelection={"multiple"}
        >
          <AgGridColumn
            width={50}
            minWidth={50}
            maxWidth={50}
            headerTooltip={accion}
            headerCheckboxSelection={true}           
           checkboxSelection={(params) => {
            return params.data?.puedeAprobar === true;
          }}
          />
          <AgGridColumn
            maxWidth={45}
            cellClass={"imagen"}
            cellRenderer="imageFormatter"
          />
          <AgGridColumn
            field="empleado.nombre"
            headerName="NOMBRE"
            flex={5}
            minWidth={280}
            cellClass={"left"}
            headerClass={"left"}
          />
          <AgGridColumn
            field="total"
            headerName="POR LIQUIDAR"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="fechaAprobacion"
            headerName="FECHA APROBACIÓN"
            minWidth={200}
            headerClass={"right"}
            cellClass={"right"}
            cellRenderer="dateFormatter"
           
          />
          <AgGridColumn
            field="sueldoBase"
            headerName="SUELDO BASE"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalComision"
            headerName="COMISIÓN"
            headerClass={"right"}
            cellClass={"right"}
            hide={!esOperador}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="estatus"
            headerName="ESTATUS"
            flex={5}
            minWidth={110}
            cellClass={"left"}
            headerClass={"left"}
          />
          <AgGridColumn
            field="totalPrestamos"
            headerName="PRÉSTAMOS"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalCajaAhorro"
            headerName="CAJA AHORRO"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalPrestamoCajaAhorro"
            headerName="PRÉSTAMO CAJA AHORRO"
            flex={5}
            minWidth={180}
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalAnticipos"
            headerName="ANTICIPOS"
            headerClass={"right"}
            cellClass={"right"}
            hide={!esOperador}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalGastos"
            headerName="GASTOS"
            maxWidth={80}
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalCompensaciones"
            headerName="COMPENSACIONES"
            headerClass={"right"}
            cellClass={"right"}
            hide={!esOperador}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalDescuentos"
            headerName="DESCUENTOS"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalGastosCajaChica"
            headerName="CAJA CHICA"
            headerClass={"right"}
            cellClass={"right"}
            hide={!esOperador}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalAjuste"
            headerName="AJUSTE"
            headerClass={"right"}
            cellClass={"right"}
            hide={!esOperador}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalBonos"
            headerName="BONOS"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalVacaciones"
            headerName="VACACIONES"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            flex={4}
            field="totalPrimaVacacional"
            headerName="PRIMA VACACIONAL"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalOtros"
            headerName="OTROS"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="totalImpuestos"
            headerName="IMPUESTOS"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />
          {/* {liquidacion.aplazarMovimientos  && */}
       
          {/* } */}
          <AgGridColumn
            flex={3}
            field="totalPensionAlimenticia"
            headerName="PENSION ALIMENTICIA"
            headerClass={"right"}
            cellClass={"right"}
            valueFormatter={agGridHelper.currencyFormatter}
          />   
          <AgGridColumn
            maxWidth={150}
            headerName="VER"
            cellRenderer="rowButtons"
            pinned={"left"}
            cellClass={"left"}
            headerComponent="buttonsHeader"
          />
        </AgGridReact>
      </div>

          <Dialog header={`Aprobar sin rendimiento - ${empleadoSeleccionado}`} visible={verModal} footer={renderFooterModal}
                    style={{width: '60vw'}} onHide={() => setVerModal(false)}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "auto" }}>
                <FieldCheckBox
                    name="liquidarSinRendimiento"
                    disabled={soloLectura}
                    value={liquidarSinRendimiento}
                    onChange={(value) => setliquidarSinRendimiento(value)}
                />
            </div>

            <span style={{ marginLeft: "8px" }}>
                Liquidar sin rendimiento
            </span>
        </div>
            <FieldTextArea name={"comentarios"} label={"Comentarios"} colMd={12} rows={3}
                        value={comentario} onChange={(value) => setComentario(value)}/>
        </Dialog>        
    </>
  );
};

const Filtros = ({
  filtro,
  onChange,
  esOperador,
  esquemaPago,
  semanaLaboral,
  consulta,
  permisoEmpleadosEnBaja,
  empresaUsuario,
}) => {
  const consultaParams = {
    operadores: esOperador,
    esquemaPago: esquemaPago,
    enBaja: filtro.enBaja
    //   empresa:filtro.empresa
  };
console.log(filtro);
  return (
    <>
      {/* <FieldDropDown name="empresa"  label="Empresa" options={empresaUsuario} required={true} filter={true} colMd={2} valueById={true}
                    value={filtro.empresa} onChange={onChange}/> */}

      <FieldMultiSelect
        name="empleadosId"
        source={consulta}
        label="Empleado"
        colLg={2}
        colMd={3}
        value={filtro.empleadosId}
        params={{ ...consultaParams }}
        onChange={onChange}
        showFilter
        valueAsId={true}
      />
        {esOperador  && 
          <FieldDropDown name="unidadNegocioId" label="Unidad de Negocio" colMd={2} source="unidadesNegocio" filter={true} className="dropdown-bottom"
            value={filtro?.unidadNegocioId}  onChange={onChange} />       
        }
         {esOperador  && 
          <FieldDropDown name="coordinadorIds" label="Coordinador" colMd={2} source="empleados" filter className="dropdown-bottom"
            params={{ puestoIds: [constantes.puestos.coordinadorTrafico, constantes.puestos.auxiliarTrafico],todasLasEmpresas: true}} 
            value={filtro?.coordinadorIds} onChange={onChange} />
         }
       {esOperador  && 
          <FieldDropDown name="estatusId" label="Estatus" colMd={2} source="estatusLiquidacion" filter={true} className="dropdown-bottom"
            value={filtro?.estatusId} onChange={onChange} />
      }
      <div className="form-group col-md-4 col-sm-12">
        <label>Rango Nómina</label>
        <div className="col-auto">
          <FieldTextBox
            name="nominaDe"
            colLg={2}
            placeholder={"Desde"}
            value={filtro.nominaDe}
            onChange={onChange}
          />
          <FieldTextBox
            name="nominaHasta"
            colLg={2}
            placeholder={"Hasta"}
            value={filtro.nominaHasta}
            onChange={onChange}
          />
          {permisoEmpleadosEnBaja && (
            <div className="col-md-4 col-sm-12">
              <div className="col-auto">
                <FieldCheckBox
                  name="enBaja"
                  colLg={8}
                  colMd={6}
                  label="Empleado en Baja"
                  value={filtro.enBaja ?? false}
                  onChange={onChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="form-group col-md-4 col-sm-12 d-flex justify-content-end ml-auto">
        <div className="text-right">
          <label>
            <b>Semana Laboral:</b>{" "}
          </label>
          {semanaLaboral.fechaInicio && semanaLaboral.fechaFin && (
            <span>
              {` ${semanaLaboral.fechaInicio} - ${semanaLaboral.fechaFin}`}
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default Liquidacion;
